

import React, { useState, useEffect } from "react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Filter: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Total: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9-4-18-3 9H2" />
        </svg>
    ),
    Accepted: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#155724" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Paid: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#004085" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Pending: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#856404" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',

        // borderRadius: '16px',
        // boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap'
    },
    filterLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#4a5568'
    },
    filterSelect: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '40px',
        minWidth: '160px',
        cursor: 'pointer'
    },
    statsContainer: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        padding: '16px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    statCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        background: 'white',
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        transition: 'all 0.2s ease'
    },
    statIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    statIconTotal: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    statIconAccepted: {
        background: '#c6f6d5',
        color: '#155724'
    },
    statIconPaid: {
        background: '#bee3f8',
        color: '#004085'
    },
    statIconPending: {
        background: '#fefcbf',
        color: '#856404'
    },
    statContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    statValue: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    statLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '800px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    badgeAccepted: {
        background: '#c6f6d5',
        color: '#155724'
    },
    badgeRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    badgePaid: {
        background: '#bee3f8',
        color: '#004085'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#856404'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    vendorId: {
        fontFamily: 'monospace',
        fontSize: '12px',
        color: '#4a5568'
    },
    enquiryId: {
        fontWeight: '600',
        color: 'rgb(230 109 51)'
    },
    vendorName: {
        fontWeight: '500',
        color: '#2d3748'
    }
};

const LeadAcceptance = () => {
    const [leads, setLeads] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);
    const [filter, setFilter] = useState("all");
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const mockLeads = [
            {
                id: 63,
                orderId: 63,
                budget: "5000",
                paymentAmount: "50",
                event: "EVENT",
                eventType: "ENGAGEMENT",
                eventDate: "23/02/2026",
                eventTime: "13:15",
                fullName: "Raj",
                name: "Raj",
                phoneNumber: "8085270852",
                mobile: "8085270852",
                email: "nag@gmail.com",
                vegPlates: 80,
                nonVegPlates: 10,
                fullAddress: "manjeera , eseva",
                city: "hyderabad",
                state: "telangana",
                country: "india",
                pincode: "500072",
                additionalRequests: "dfgg",
                adminPermision: true,
                items: [
                    "mutton",
                    "Veg Manchurian",
                    "Paneer Tikka",
                    "Paneer 65",
                    "Mushroom 65",
                    "dosa",
                    "Gobi Manchurian",
                    "Baby Corn Manchurian",
                    "Chiken"
                ],
                addOns: [],
                vendorResponses: [
                    {
                        vendorId: 101,
                        vendorName: "Fresh Foods Catering",
                        email: "freshfoods@gmail.com",
                        phone: "9876543210",
                        location: "Hyderabad",
                        accepted: true,
                        acceptedDate: "22/02/2026",
                        paid: true,
                        paidDate: "22/02/2026",
                        paymentAmount: "500",
                        paymentMethod: "UPI",
                        transactionId: "TXN123456789",
                        rating: 4.5,
                        feedback: "Good customer, will serve well"
                    },
                    {
                        vendorId: 102,
                        vendorName: "Spice Garden",
                        email: "spicegarden@gmail.com",
                        phone: "9123456780",
                        location: "Bangalore",
                        accepted: true,
                        acceptedDate: "22/02/2026",
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: "Accepted but payment pending"
                    },
                    {
                        vendorId: 103,
                        vendorName: "Royal Dine Services",
                        email: "royaldine@gmail.com",
                        phone: "9988776655",
                        location: "Chennai",
                        accepted: false,
                        acceptedDate: null,
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: null
                    },
                    {
                        vendorId: 104,
                        vendorName: "Urban Tadka Caterers",
                        email: "urbantadka@gmail.com",
                        phone: "9012345678",
                        location: "Mumbai",
                        accepted: true,
                        acceptedDate: "21/02/2026",
                        paid: true,
                        paidDate: "21/02/2026",
                        paymentAmount: "500",
                        paymentMethod: "Credit Card",
                        transactionId: "TXN987654321",
                        rating: 5,
                        feedback: "Excellent communication"
                    },
                    {
                        vendorId: 105,
                        vendorName: "Grand Feast Events",
                        email: "grandfeast@gmail.com",
                        phone: "9090909090",
                        location: "Delhi",
                        accepted: false,
                        acceptedDate: null,
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: null
                    }
                ]
            },
            {
                id: 64,
                orderId: 64,
                budget: "8000",
                paymentAmount: "80",
                event: "WEDDING",
                eventType: "RECEPTION",
                eventDate: "25/02/2026",
                eventTime: "19:00",
                fullName: "Priya Sharma",
                name: "Priya Sharma",
                phoneNumber: "9876543210",
                mobile: "9876543210",
                email: "priya@gmail.com",
                vegPlates: 100,
                nonVegPlates: 50,
                fullAddress: "Green Park, Delhi",
                city: "Delhi",
                state: "Delhi",
                country: "india",
                pincode: "110001",
                additionalRequests: "Need vegetarian options",
                adminPermision: true,
                items: [
                    "Paneer Butter Masala",
                    "Dal Makhani",
                    "Naan",
                    "Gulab Jamun",
                    "Chicken Biryani"
                ],
                addOns: [],
                vendorResponses: [
                    {
                        vendorId: 101,
                        vendorName: "Fresh Foods Catering",
                        email: "freshfoods@gmail.com",
                        phone: "9876543210",
                        location: "Hyderabad",
                        accepted: true,
                        acceptedDate: "23/02/2026",
                        paid: true,
                        paidDate: "23/02/2026",
                        paymentAmount: "800",
                        paymentMethod: "Bank Transfer",
                        transactionId: "TXN555555555",
                        rating: 4,
                        feedback: "Will manage the event"
                    },
                    {
                        vendorId: 105,
                        vendorName: "Grand Feast Events",
                        email: "grandfeast@gmail.com",
                        phone: "9090909090",
                        location: "Delhi",
                        accepted: true,
                        acceptedDate: "23/02/2026",
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: "Accepted, waiting for payment"
                    }
                ]
            }
        ];

        setLeads(mockLeads);
    }, []);

    const getFilteredVendors = (vendorResponses) => {
        switch (filter) {
            case "accepted":
                return vendorResponses.filter(v => v.accepted === true);
            case "paid":
                return vendorResponses.filter(v => v.paid === true);
            default:
                return vendorResponses;
        }
    };

    const getAllVendorResponses = () => {
        let allResponses = [];
        leads.forEach(lead => {
            lead.vendorResponses.forEach(vendor => {
                allResponses.push({
                    ...vendor,
                    enquiryId: lead.orderId,
                    customerName: lead.fullName,
                    eventType: lead.eventType,
                    eventDate: lead.eventDate,
                    budget: lead.budget
                });
            });
        });
        return allResponses;
    };

    const getFilteredResponses = () => {
        const allResponses = getAllVendorResponses();
        switch (filter) {
            case "accepted":
                return allResponses.filter(v => v.accepted === true);
            case "paid":
                return allResponses.filter(v => v.paid === true);
            default:
                return allResponses;
        }
    };

    const getStatistics = () => {
        const allResponses = getAllVendorResponses();
        const total = allResponses.length;
        const accepted = allResponses.filter(v => v.accepted).length;
        const paid = allResponses.filter(v => v.paid).length;
        const pending = accepted - paid;
        return { total, accepted, paid, pending };
    };

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const stats = getStatistics();
    const filteredResponses = getFilteredResponses();

    return (
        <div style={styles.container}>
            {/* Header */}
            {/* <div style={styles.header}>
                <div style={styles.title}>
                    📋 Lead Acceptance
                    <span style={styles.titleBadge}>{stats.total}</span>
                </div>
                <div style={styles.filterGroup}>
                    <span style={styles.filterLabel}>
                        <Icons.Filter /> Filter:
                    </span>
                    <select
                        value={filter}
                        onChange={handleFilterChange}
                        style={styles.filterSelect}
                    >
                        <option value="all">All Vendors</option>
                        <option value="accepted">Accepted Only</option>
                        <option value="paid">Paid Only</option>
                    </select>
                </div>
            </div> */}

            {/* Stats Cards */}
            <div style={styles.statsContainer}>
                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconTotal }}>
                        <Icons.Total />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.total}</span>
                        <span style={styles.statLabel}>Total Vendors</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconAccepted }}>
                        <Icons.Check />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.accepted}</span>
                        <span style={styles.statLabel}>Accepted</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPaid }}>
                        <Icons.Money />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.paid}</span>
                        <span style={styles.statLabel}>Paid</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPending }}>
                        <Icons.Pending />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.pending}</span>
                        <span style={styles.statLabel}>Pending Payment</span>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>Enquiry ID</th>
                            <th style={styles.th}>Vendor ID</th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Vendor /> Vendor Name
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Location /> Location
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Calendar /> Accepted
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredResponses.length > 0 ? (
                            filteredResponses.map((vendor, index) => (
                                <tr
                                    key={`${vendor.enquiryId}-${vendor.vendorId}`}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td }}>
                                        <span style={styles.enquiryId}>#{vendor.enquiryId}</span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={styles.vendorId}>#{vendor.vendorId}</span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={styles.vendorName}>{vendor.vendorName}</span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Icons.Location /> {vendor.location}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {vendor.accepted ? (
                                            <span style={{ ...styles.badge, ...styles.badgeAccepted }}>
                                                <Icons.Check /> Accepted
                                            </span>
                                        ) : (
                                            <span style={{ ...styles.badge, ...styles.badgeRejected }}>
                                                <Icons.X /> Rejected
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {vendor.acceptedDate || "N/A"}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {vendor.paid ? (
                                            <span style={{ ...styles.badge, ...styles.badgePaid }}>
                                                <Icons.Money /> Paid
                                            </span>
                                        ) : vendor.accepted ? (
                                            <span style={{ ...styles.badge, ...styles.badgePending }}>
                                                <Icons.Pending /> Pending
                                            </span>
                                        ) : (
                                            <span style={{ ...styles.badge, ...styles.badgeDefault }}>N/A</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No vendors match the selected filter</div>
                                        <div style={styles.emptyStateSubtext}>Try adjusting your filter to see more results</div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Responsive Styles */}
            <style>{`
                @media (max-width: 768px) {
                    .stat-card {
                        flex: 1 1 calc(50% - 6px) !important;
                        min-width: 120px !important;
                    }
                    
                    .stat-value {
                        font-size: 16px !important;
                    }
                    
                    .stat-label {
                        font-size: 10px !important;
                    }
                    
                    .filter-select {
                        min-width: 120px !important;
                        font-size: 12px !important;
                        padding: 6px 10px !important;
                    }
                }

                @media (max-width: 480px) {
                    .stat-card {
                        flex: 1 1 calc(50% - 4px) !important;
                        min-width: 80px !important;
                        padding: 6px 10px !important;
                    }
                    
                    .stat-icon {
                        width: 28px !important;
                        height: 28px !important;
                    }
                    
                    .stat-value {
                        font-size: 14px !important;
                    }
                    
                    .stat-label {
                        font-size: 9px !important;
                    }
                    
                    .table-container table {
                        font-size: 11px !important;
                    }
                    
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    
                    .badge {
                        font-size: 9px !important;
                        padding: 2px 8px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }
            `}</style>
        </div>
    );
};

export default LeadAcceptance;